import _ from 'lodash';
import CustomerType from '../const/customer_type';
import { getCurrentCustomerType } from '../selectors/customer_type_selector';

export const isCurrentCustomerTypeMatchWith = (currentCustomerType, newCustomerType) => {
  return currentCustomerType === newCustomerType;
};

export const isProductCustomerTypesMatchWith = (productCustomerTypes, customerType) => {
  return productCustomerTypes
    && productCustomerTypes.length > 0
    && (productCustomerTypes.indexOf(CustomerType.ALL) > -1
        || productCustomerTypes.indexOf(customerType) > -1);
};

export const isCustomerTypeValid = (customerType) => {
  return customerType === CustomerType.ADULT 
    || customerType === CustomerType.MEDICAL;
}

// eslint-disable-next-line no-underscore-dangle
export const _isProductInCartAndCustomerTypeMismatch = (
  newlySelectedCustomerType,
  selectedProductCustomerTypes,
  isTaxByPackageCustomerType,
  typesToValidate,
) => {
  if (!selectedProductCustomerTypes || !_.includes(typesToValidate, newlySelectedCustomerType)) {
    return false;
  }

  if (newlySelectedCustomerType === CustomerType.ADULT) {
    return !isProductCustomerTypesMatchWith(
      selectedProductCustomerTypes,
      newlySelectedCustomerType,
    );
  }

  if (newlySelectedCustomerType === CustomerType.MEDICAL && isTaxByPackageCustomerType) {
    return !isProductCustomerTypesMatchWith(
      selectedProductCustomerTypes,
      newlySelectedCustomerType,
    );
  }
};

export const isProductInCartAndCustomerTypeMismatch = (
  newlySelectedCustomerType,
  selectedProductCustomerTypes,
  isTaxByPackageCustomerType,
) => _isProductInCartAndCustomerTypeMismatch(
  newlySelectedCustomerType,
  selectedProductCustomerTypes,
  isTaxByPackageCustomerType,
  [CustomerType.ADULT],
);

export const guessPackageCustomerType = (state, packageCustomerTypesString) => {
  const customerType = getCurrentCustomerType(state);
  const packageCustomerTypes = (packageCustomerTypesString || '').split(',');
  
  if (customerType === CustomerType.MEDICAL) {
    if (packageCustomerTypes.indexOf(customerType) > -1) {
      return CustomerType.MEDICAL;
    }
    if (packageCustomerTypes.indexOf(CustomerType.ALL) > -1) {
      return CustomerType.ALL;
    }
    if (packageCustomerTypes.indexOf(CustomerType.ADULT) > -1) {
      return CustomerType.ADULT;
    }
  }

  if (customerType === CustomerType.ADULT) {
    if (packageCustomerTypes.indexOf(CustomerType.ALL) > -1) {
      return CustomerType.ALL;
    }
    if (packageCustomerTypes.indexOf(CustomerType.ADULT) > -1) {
      return CustomerType.ADULT;
    }
  }

  return customerType;
};



// WEBPACK FOOTER //
// ./src/helpers/customer_type_helper.js